export const TOOTH_IMAGE_BASE = {
	w: 280,
	h: 509,
};
